import { DashboardViewOnFetchDataEpic } from './DashboardViewOnFetchDataEpic';
import { DashboardViewInitEpic } from './DashboardViewInitEpic';
import { DashboardViewOnRouteEpic } from './DashboardViewOnRouteEpic';

export const rootDashboardViewEpics = [
  DashboardViewOnRouteEpic,
  DashboardViewInitEpic,
  DashboardViewOnFetchDataEpic,
];
